<div class="fake-radio-comp" [class.great-ico]="checked">
    <div [class.great]="checked" class="fake-radio-center" fxFlex></div>
</div>